module.exports = __webpack_public_path__ + "img/otp.36a45822.png";